(function($) {
  var $body = $('body');
  var BUTTON = {
    toggleClass: 'side-panel-show'
  }

  var sidePanel = {
    show: function() {
      $body.addClass(BUTTON.toggleClass);
      clickOutsideClose();
    },
    hide: function() {
      $body.removeClass(BUTTON.toggleClass);
    },
    toggle: function() {
      !$body.hasClass(BUTTON.toggleClass)
        ? this.show()
        : this.hide();
    },
    isShow: function() {
      return $body.hasClass(BUTTON.toggleClass);
    }
  }

  function clickOutsideClose() {
    $(document).on('click.sidePanel', event => {
      var target = event.target;
      if (!$(target).closest('.side-panel, .side-panel-toggle').length) {
        sidePanel.hide();
        $(document).off('click.sidePanel');
      }
    });
  }

  function hidePanelOnDesktop() {
    if (window.innerWidth > 1140 && sidePanel.isShow()) {
      sidePanel.hide();
    }
  }

  window.addEventListener('resize', hidePanelOnDesktop);
  $('.side-panel-toggle').on('click', () => sidePanel.toggle());
})(jQuery);